import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";

interface MostViewedStartup {
  startup_id: string;
  title: string;
  view_count: number;
  trend_score: number;
}

interface Props {
  data: MostViewedStartup[];
}

const COLORS = [
  "hsl(var(--primary))",
  "hsl(var(--accent))",
  "hsl(var(--secondary))",
  "hsl(220, 70%, 50%)",
  "hsl(280, 70%, 50%)",
  "hsl(340, 70%, 50%)",
  "hsl(40, 70%, 50%)",
  "hsl(160, 70%, 50%)",
  "hsl(200, 70%, 50%)",
  "hsl(260, 70%, 50%)",
];

export default function MostViewedStartupsChart({ data }: Props) {
  if (!data || data.length === 0) {
    return (
      <div className="h-80 flex items-center justify-center text-muted-foreground">
        No startup views data available
      </div>
    );
  }

  const chartData = data.map((item) => ({
    ...item,
    shortTitle: item.title.length > 20 ? item.title.substring(0, 20) + "..." : item.title,
  }));

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={chartData} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis type="number" className="text-xs" />
        <YAxis 
          dataKey="shortTitle" 
          type="category" 
          width={150}
          className="text-xs"
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: "hsl(var(--background))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "8px"
          }}
          formatter={(value, name) => {
            if (name === "view_count") return [value, "Views"];
            return [value, name];
          }}
        />
        <Bar dataKey="view_count" radius={[0, 8, 8, 0]}>
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
